(function($){
	
	var formScroll = function(){

		$(document).bind('gform_confirmation_loaded', function(event, formId){
			//console.log('sbmt');
			$('html,body').animate({
				scrollTop: $('.contact-page-form').offset().top - $('.site-header').outerHeight() - 30 
			}, 500);
		});
	}
	
	var megaNav = function(){
		$('.site-header__menu .menu-item-has-children').mouseenter(function(){
			$('.menu-item-has-children').not(this).removeClass('hover');
			$(this).addClass('hover');
		});
		$('.site-header').mouseleave(function(){
			$('.menu-item-has-children').removeClass('hover');
		});
	};

	var sidebarNav = function(){
		var stickyNav = $('.sub-section-nav');
		
		stickyNav.stick_in_parent({
			offset_top: 100
		}).on('sticky_kit:bottom', function(e) {
			stickyNav.removeClass('not-bottom');
		}).on('sticky_kit:unbottom', function(e) {
			stickyNav.addClass('not-bottom');
		});
		
		var header = $('.site-header');
		$('[data-action="scrollLink"]').on('click', function(e){
			e.preventDefault();
			
			var target = $(this.hash);
			
			$('body,html').animate({
				scrollTop : target.offset().top - header.outerHeight()
			});
		});
	};
	
	var filterScroll = function(){
		var header = $('.site-header');
		
		if(
			($('body').hasClass('archive') && $('body').hasClass('category'))
			|| ( $('body').hasClass('post-type-archive-case_studies_module') && getParameterByName('market_id'))
		){
			var scrollTarget = $('.archive-list');
			
			$('body,html').animate({
				scrollTop : scrollTarget.offset().top - header.outerHeight() - 20
			});
		}
	};
		   
	var getParameterByName = function(name, url) {
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, '\\$&');
		var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
		results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, ' '));
		
		//var foo = getParameterByName('foo'); 
	};
	
	var scrollToAnchor = function(){
		
		$('.site-header a, #ocn a').on('click', function(e){
			
			if(this.hash){
				/*var headerHeight = 0;
				$('.menu-item-has-children').removeClass('hover');
				setTimeout(function(){
					headerHeight = $('.site-header').outerHeight();
				}, 500);*/
				$('body').removeClass('nav-open');
				
				var hashTarget = $(this.hash);
				//console.log(this.hash);
				if( hashTarget.length ){
					e.preventDefault();
					var anchorPosition = hashTarget.offset().top;
					var finalPosition = anchorPosition - $('.site-header').outerHeight();
					$("html, body").animate({scrollTop: finalPosition}, 250);
					$('body').removeClass('nav-open');
				}
			}
		});
		
		if(window.location.hash != ""){
			var winhash = window.location.hash;
			//console.log(winhash);
			var hashTarget = $(winhash);
			
			if( hashTarget.length ){
				var anchorPosition = hashTarget.offset().top;
				var finalPosition = anchorPosition - $('.site-header').outerHeight();
				$("html, body").animate({scrollTop: finalPosition}, 250);
				$('body').removeClass('nav-open');
			}
		}

	};
	
	var heroSlider = function(){
		$('.hero-slider').slick({
			autoplay: true,
			autoplaySpeed: 3000,
			arrows: false,
			dots: false,
			pauseOnHover: false,
			speed: 2000
		});
	};

	$(document).ready(function(){
		formScroll();
		megaNav();
		sidebarNav();
		filterScroll();
		scrollToAnchor();
		heroSlider();
	});

})(jQuery);